export interface Contact {
    identifier: string;
}

export interface BankAccount {
    caRoutingInfo?: any;
    identifier: string;
}

export interface Transaction {
    identifier: string;
    amount: number;
    contact: Contact;
    toBankAccount: BankAccount;
}

export interface TransactionSessionData {
    transactionId: string;
    redirectUrl: string;
    tokenizePaymentMethod: boolean;
}

export interface CheckoutConfig {
    clientKey: string;
    environment: string;
    amount?: {
        value: number;
        currency: string;
    };
    locale: string;
    countryCode?: string;
}

export interface CardConfig {
    enableStoreDetails: boolean;
}

export interface PaymentSessionConfig {
    transactionSessionData: TransactionSessionData;
    encodedSessionData: string;
    checkoutConfigurationData: CheckoutConfig;
    cardConfigurationData: CardConfig;
}

export interface TokenizationSessionConfig {
    encodedSessionData: string;
    checkoutConfigurationData: CheckoutConfig;
    cardConfigurationData: CardConfig;
}

export interface CardDetails {
    brand: string;
    last4: string;
}

export type ErrorWithState = Error & { state?: Record<string, unknown> };